import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { MasterData } from '@model/master-data.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private translate: TranslateService) {}

  markFormGroupTouched(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls)
      .map((item: any) => formGroup.controls[item])
      .forEach((control: UntypedFormGroup) => {
        control.markAsTouched();
        if (control.controls) {
          this.markFormGroupTouched(control);
        }
      });
  }

  convertCurrencyToNumber(currency: string): number {
    if (!currency) {
      return 0;
    }

    return Number(currency.replace(/[^0-9.-]+/g, ''));
  }

  searchAddressDropdown(searchKeyword: string, { descEn, descTh }: MasterData): boolean {
    const keyword: string = searchKeyword.toLowerCase();

    const engDescription: string = descEn.toLowerCase();
    const thaiDescription: string = descTh.toLowerCase();

    return engDescription.includes(keyword) || thaiDescription.includes(keyword);
  }

  searchMasterDataDropdown(searchKeyword: string, { descEn, descTh }: MasterData): boolean {
    const keyword: string = searchKeyword.toLowerCase();

    if (this.translate.currentLang === 'en') {
      const engDescription: string = descEn.toLowerCase();
      return engDescription.includes(keyword);
    } else {
      const thaiDescription: string = descTh.toLowerCase();
      return thaiDescription.includes(keyword);
    }
  }
}
